import { API, ContentAPI } from "../../utils/api.config";
import { API_URL } from "../../utils/api-url.config";
import axios from "axios";

export async function getResponsePackages() {
  return await API.get(`/api/v2/packages`);
}
export async function getResponsePackagesByCountry(country_code) {
  return await API.get(`/api/v2/packages?country=${country_code}`);
}
// TODO: replace with the final route once the backend endpoint is ready
export async function getResponsePackagesByPackageType({
  country_code,
  packageType,
}) {
  return await API.get(
    `/api/v2/packages?country=${country_code}&package=${packageType}`,
  );
}
export async function getResponsePackagesByCoupon({ couponCode, productId }) {
  return await API.post(`/payment/api/v1/coupon/validate`, {
    couponCode,
    productId,
  });
}
export async function getTvodPackagesByCountry({
  localContentId,
  country,
  localIsTvod,
}) {
  if (localIsTvod === false || localIsTvod === "false") {
    return await API.get(
      `/api/v2/packages?content_id=${localContentId}&country=${country}&svod=true`,
    );
  } else {
    return await API.get(
      `/api/v2/packages?content_id=${localContentId}&country=${country}&tvod=${localIsTvod}`,
    );
  }
}
export async function getUserLocation() {
  return await API.get(`/api/user/location`);
}
export async function getContentById(contentId) {
  return await ContentAPI.get(`/api/content/trailer/${contentId}`);
}
// export async function getContentById(id, type) {
//   return await API.get(`api/artist/page/details/${id}?page=1&type=${type}`);
// }

export async function generateShortToken() {
  try {
    const response = await axios.post(`${API_URL}auth/token/temp`, {
      platform: "iscreen",
    });
    const tempToken = await response?.data?.token;
    return tempToken;
  } catch (error) {
    console.log("Error getting token or platform", error);
  }
}
